<template>
  <div v-if="paginas.length > 0">
    <novotopo :atual="paginas" :pagina="paginaAtual" @mudadepagina="changePage" :user="userisloged"></novotopo>
    <conteudotext :atual="paginas[paginaAtual]" v-if="paginas[paginaAtual].tipo == 'texto'"></conteudotext>
    <conteudovideo :atual="paginas[paginaAtual]" v-if="paginas[paginaAtual].tipo == 'video'"></conteudovideo>
    <diferenciais v-if="paginas[paginaAtual].tipo == 'diferenciais'"></diferenciais>
    <horarios v-if="paginas[paginaAtual].tipo == 'horario'"></horarios>
    <footerintegracao :atual="paginas" :pagina="paginaAtual" @mudadepagina="changePage" v-if="paginas"></footerintegracao>
  </div>
  <div v-else>

  </div>
</template>

<script>
  import  novotopo from './Paginas/topo.vue'
  import  conteudotext from './Paginas/ConteudoTexto.vue'
  import  conteudovideo from './Paginas/ConteudoVideo.vue'
  import  footerintegracao from './Paginas/footer.vue'
  import  diferenciais from './Paginas/Diferenciais.vue'
  import  horarios from './Paginas/horarios.vue'

  import moduleIntegracao from "../../store/integracao/moduleIntegracao";

  // Base css
  import "@/assets/css/integracao.css";

  export default {
    name: "Main",
    components:{
      novotopo,
      conteudotext,
      footerintegracao,
      conteudovideo,
      diferenciais,
      horarios,
    },
    data(){
      return{
        user:'Ana',
        paginas:[],
        paginaAtual: 0,
        backgroundLoading: '#ffffff',
      }
    },
    created() {
      if (!this.userisloged){
        this.$router.push({name:'novaintegracao-login'})
      }
      if (!moduleIntegracao.isRegistered) {
        this.$store.registerModule("integracao", moduleIntegracao);
        moduleIntegracao.isRegistered = true;
      }
      this.getPaginas();


      console.log('Variavel',this.paginas)
    },
    mounted(){
      this.$nextTick(function () {

      })
    },
    computed: {
      currentStep() {
        return this.$store.state.integracao.step;
      },
      userisloged(){
        let user = localStorage.getItem('integracaoLogged')
        return JSON.parse(user);
      }
    },
    methods: {
      getPaginas(){
        this.$store.dispatch("integracao/getPaginas").then((response) => {
          console.log('paginas', response);
          this.paginas = response.data;
          //tratamento de rotas
          if (this.$route.params.id > this.paginas.length) {
            this.$router.push({name: 'integracao-slides', params: {id: 1}})
          } else {
            this.paginaAtual = this.$route.params.id - 1;
          }
        });
      },
      changePage(page){
        console.log('pagina alterada',page);
        if (page > 0  && page <=  this.paginas.length) {
          this.$vs.loading({ background: this.backgroundLoading, color: 'rgb(198, 21, 23)' })
          setTimeout(() => {
            this.$router.push({name:'integracao-slides',params:{id:page}})
            this.paginaAtual = page - 1;

            this.$vs.loading.close()
          }, 300);

        }
      },
    },

  };
</script>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@600;900&family=Roboto:wght@300;400;900&display=swap");
</style>
